/* eslint-disable camelcase */
import axios from 'axios';
import { GIFT_TABLE_ROOT as ROOT, BASE_PATH_API } from 'constants/env';
import {
  transformListParams,
  transformListRes,
} from 'services/commons/transformers';

export async function getCart({ id, ...params } = {}) {
  const url = `${BASE_PATH_API}/${ROOT}/gift-table-cart/${id}`;
  //  console.log("URL getCart: ",url);
  const res = await axios({ url, params: {} || transformListParams(params) });
  const { data, pagination } = res.data;

  return transformListRes(data, pagination);
}

export async function getListOfTableCarts(params = {}) {
  const paramsWithPagination = {
    ...params,
    ...transformListParams(params),
  };

  // Preparando Set paramsWithPagination para agregar el nodo cart_id
  if(paramsWithPagination.customer_sears_id === undefined) {
    paramsWithPagination.customer_sears_id = 0;
    paramsWithPagination.cart_id = localStorage.getItem("cart_id");
    paramsWithPagination.guest_email = localStorage.getItem("guest_email");
    paramsWithPagination.guest_phone_number = localStorage.getItem("guest_phone_number");

    //  console.log("PREPARANDO PARA ENVIAR paramsWithPagination CON cart_id en get");
    //  console.log("paramsWithPagination: ",paramsWithPagination);
  }

  const url = `${BASE_PATH_API}/${ROOT}/gift-table-cart`;
  //  console.log('URL getListOfTableCarts: ',url,'Params: ',paramsWithPagination);
  const res = await axios({ url, params: paramsWithPagination });

  const { data, pagination } = res.data;

  return transformListRes(data, pagination);
}

export async function getHaveAShoppingCart(params = {}) {
  try {
    const { list = [] } = await getListOfTableCarts(params);
    return [true, list[0]];
  } catch (error) {
    const notFoundCart = error.response.status === 404;
    return [notFoundCart ? false : null, null];
  }
}

export async function patchCart({ id, ...data } = {}) {
  const url = `${BASE_PATH_API}/${ROOT}/gift-table-cart/${id}`;
  const res = await axios({ url, method: 'PATCH', data });
  return res.data;
}

export async function postCart({ tableId, ...data } = {}) {
  const url = `${BASE_PATH_API}/${ROOT}/gift-table/${tableId}/carts`;
  const res = await axios({ url, method: 'post', data });
  return res.data.data;
}

export async function deleteProductCart({
  id,
  product_sears_id,
  variant_sears_id = '',
} = {}) {
  const url = `${BASE_PATH_API}/${ROOT}/gift-table-cart/${id}`;
  const res = await axios({
    url,
    method: 'DELETE',
    params: {
      product_sears_id: product_sears_id,
      variant_sears_id: variant_sears_id,
    },
  });
  return res.data.data;
}

export async function putCart({ id, ...data } = {}) {
  const url = `${BASE_PATH_API}/${ROOT}/gift-table-cart/${id}`;
  const res = await axios({ url, method: 'PUT', data });
  return res.data.data;
}

export async function postCartInfo(data) {
  try{
    const url = `${BASE_PATH_API}/caja/api/inicio/mesa-regalos`;
    const res = await axios({ url, method: 'post', data });
    //  console.log("url postCartInfo: ",url);
    //  console.log("Resultado postCartInfo: ",res);
    const KEY = 'CSC-KEY';
    const key = {
      identifier: KEY,
      value: res.headers[KEY.toLowerCase()],
    };
    console.log("Resultado postCartInfo ",res);
    //  console.log("Resultado postCartInfo (key)",key);
    window.localStorage.setItem('statusRedirectCaja', res.status);
    console.log('Muestra statusRedirectCaja OK: ', res.status);
    return [res.data.data, key, res.status];
  } catch (error) {
    // Aquí puedes manejar el error de acuerdo a tus necesidades
    console.error('Error al enviar a caja: ', error.response.data.data.error);
    console.error('Error al enviar a caja code: ', error.response.status);
    window.localStorage.setItem('statusRedirectCaja', error.response.status);
    console.log('Muestra statusRedirectCaja ERROR: ', error.response.status);
    return [res.data.data, key, error.response.status];
  }
}
